import ACTIONS from '@/store/storeActions';

const actions = {
  [ACTIONS.SET_USERS]: (context, payload) => context.commit(ACTIONS.SET_USERS, payload),
  [ACTIONS.CREATE_USER]: (context, payload) => context.commit(ACTIONS.CREATE_USER, payload),
  [ACTIONS.UPDATE_USER]: (context, payload) => context.commit(ACTIONS.UPDATE_USER, payload)
}

export default actions
